import { tv } from 'tailwind-variants'

export const ringsVariants = tv({
  base: [
    'absolute z-0 -translate-x-1/2 -translate-y-1/2',
    'top-1/2 left-1/2',
    'opacity-10 rounded-full',
    'pointer-events-none'
  ],
  variants: {
    variant: {
      solid: 'border border-white',
      gradient: 'bg-neutral-gradient'
    },
    accentColor: {
      none: '',
      yellow: '',
      green: '',
      blue: '',
      pink: ''
    },
    size: {
      sm: 'w-[78px] h-[78px]',
      md: 'w-[128px] h-[128px]',
      lg: 'w-[168px] h-[168px]',
      xl: 'w-[208px] h-[208px]'
    }
  },
  defaultVariants: {
    variant: 'solid',
    accentColor: 'none'
  },
  compoundVariants: [
    {
      variant: 'gradient',
      accentColor: 'none',
      class: 'bg-neutral-gradient'
    },
    {
      variant: 'gradient',
      accentColor: 'yellow',
      class: 'bg-yellow-neutral-gradient'
    },
    {
      variant: 'gradient',
      accentColor: 'green',
      class: 'bg-green-gradient'
    },
    {
      variant: 'gradient',
      accentColor: 'blue',
      class: 'bg-blue-gradient'
    }
  ]
})
